export function resolveUserHasQualificationEffectiveCost(payload: {
  cost?: number | null;
  internalCost?: number | null;
  qualificationCost?: number | null;
  paidByEmployee?: boolean;
}): number {
  if (payload.paidByEmployee) {
    return 0;
  }

  const baseCost: number = payload.cost ?? payload.qualificationCost ?? 0;

  return baseCost + (payload.internalCost ?? 0);
}
